<div class="container-fluid">
  <!-- Filtros -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Filtros</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="filtroForm" (ngSubmit)="aplicarFiltros()">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="cliente">Auditoria</label>
                  <input type="text" class="form-control" id="cliente" formControlName="cliente">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="tipo">Tipo de Auditoria</label>
                  <select class="form-control" id="tipo" formControlName="tipo">
                    <option value="">Todos</option>
                    <option *ngFor="let tipo of tiposAuditoria" [value]="tipo.id">
                      {{ tipo.nome }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="status">Status</label>
                  <select class="form-control" id="status" formControlName="status">
                    <option value="">Todos</option>
                    <option *ngFor="let status of statusAuditoria" [value]="status.id">
                      {{ status.nome }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="dataInicio">Data Início</label>
                  <input type="date" class="form-control" id="dataInicio" formControlName="dataInicio">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="dataFim">Data Fim</label>
                  <input type="date" class="form-control" id="dataFim" formControlName="dataFim">
                </div>
              </div>
              <div class="col-md-9">
                <div class="form-group d-flex align-items-end h-100">
                  <button type="submit" class="btn btn-primary mr-2">
                    <i class="feather icon-search"></i> Filtrar
                  </button>
                  <button type="button" class="btn btn-secondary" (click)="limparFiltros()">
                    <i class="feather icon-refresh-cw"></i> Limpar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela de Auditorias -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Auditorias</h4>
        </div>
        <div class="card-body">
          <table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Cliente</th>
                <th>Tipo</th>
                <th>Data Início</th>
                <th>Data Fim</th>
                <th>Responsável</th>
                <th>Pontuação</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let auditoria of auditorias">
                <td>{{ auditoria.id }}</td>
                <td>{{ auditoria.cliente }}</td>
                <td>{{ getTipoNome(auditoria.tipo) }}</td>
                <td>{{ auditoria.dataInicio | date:'dd/MM/yyyy' }}</td>
                <td>{{ auditoria.dataFim | date:'dd/MM/yyyy' }}</td>
                <td>{{ auditoria.responsavel }}</td>
                <td [class]="getPontuacaoClass(auditoria.pontuacao)">
                  {{ auditoria.pontuacao > 0 ? auditoria.pontuacao + '%' : '-' }}
                </td>
                <td>
                  <span [class]="'badge ' + getStatusClass(auditoria.status)">
                    {{ getStatusNome(auditoria.status) }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-info mr-1" title="Visualizar">
                    <i class="feather icon-eye"></i>
                  </button>
                  <button class="btn btn-sm btn-primary mr-1" title="Editar">
                    <i class="feather icon-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-success" title="Relatório">
                    <i class="feather icon-file-text"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div> 